import AddValueNarrativeModal from './AddValueNarrativeModal'
import { Fade, SvgIcon } from '@mui/material'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { ReactComponent as VMIcon } from '../../../../assets/images/VM_Icon.svg'
import React, { useMemo, useState } from 'react'
import { useIsSnapshotMode } from '../../../../shared/hooks/useIsSnapshotMode'
import { useIsRoadmapReadonly } from '../../../../shared/hooks/useIsRoadmapReadonly'
import { ValueMessagesLegend } from './ValueMessagesLegend'
import { ValueNarrative, ValueNarrativeCategory } from '../../queries/useGetValueNarrativesQuery'
import Box from '@mui/material/Box'
import useValueNarrativeDisplayName from '../../../../shared/hooks/useDisplayNames/variants/useValueNarrativeDisplayName'
import { PopoverComments } from '../../../../shared/components/Comments/variants/PopoverComments/PopoverComments'
import { useSelector } from 'react-redux'
import ValueNarrativesLegend from '../../../../views/ValueCompendium/tabs/ValueNarrativesTab/components/ValueNarrativesLegend'

type Props = {
    selectedCategory: ValueNarrativeCategory
    selectedNarrative: ValueNarrative
    categories: ValueNarrativeCategory[]
}

export const ValueNarrativesHeader = ({ selectedCategory, selectedNarrative, categories }: Props) => {
    const [isAddValueNarrativeModalOpen, setIsAddValueNarrativeModalOpen] = useState(false)

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const isSnapshotMode = useIsSnapshotMode()
    const isReadonlyMode = useIsRoadmapReadonly()

    const valueNarrativeDisplayName = useValueNarrativeDisplayName()

    const narratives: ValueNarrative[] = useMemo(() => {
        return categories.reduce((acc, category) => [...acc, ...category.narratives], [])
    }, [categories])

    return (
        <>
            <AddValueNarrativeModal
                isOpen={isAddValueNarrativeModalOpen}
                handleClose={() => setIsAddValueNarrativeModalOpen(false)}
                categories={categories}
                selectedCategory={selectedCategory}
            />
            <Fade in timeout={1000} unmountOnExit mountOnEnter>
                <Grid container alignItems="flex-start" gap={4}>
                    <Grid container item xs spacing={2}>
                        <Grid
                            container
                            item
                            alignItems="center"
                            spacing={2}
                            sx={{
                                flexWrap: 'nowrap',
                                textWrap: 'nowrap',
                            }}
                        >
                            <Grid item>
                                <SvgIcon component={VMIcon} fontSize="large" />
                            </Grid>
                            <Grid item>
                                <Typography variant="h1">{valueNarrativeDisplayName.plural}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={2}>
                            <Grid item>
                                {!isSnapshotMode && !isReadonlyMode && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => setIsAddValueNarrativeModalOpen(true)}
                                        style={{ width: 140, height: 52, borderRadius: '14px' }}
                                    >
                                        Add New
                                    </Button>
                                )}
                            </Grid>
                            <Grid item>
                                <Grid item>
                                    <PopoverComments dataId={strategyId} dataType="valueMessageTable" />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box py={2} minHeight="161px">
                        {!!selectedNarrative ? (
                            <ValueMessagesLegend />
                        ) : (
                            <ValueNarrativesLegend narratives={narratives} />
                        )}
                    </Box>
                </Grid>
            </Fade>
        </>
    )
}
